import { forwardRef, useId } from 'react';

import { Icon, IconKey } from '@/shared/components';
import { Input } from '../ui';
import { Field, FieldDescription, FieldError, FieldLabel } from '../ui/field';

interface FieldCurrencyInputProps extends React.ComponentProps<'input'> {
  label: string;
  description?: string;
  errors?: Array<{ message?: string } | undefined>;
}

export const FieldCurrencyInput = forwardRef<HTMLInputElement, FieldCurrencyInputProps>(function FieldCurrencyInput(
  {
    id,
    value,
    label,
    description,
    errors,
    placeholder = '0.00',
    required = false,
    disabled = false,
    ...props
  },
  ref
) {
  const internalId = useId();
  const inputId = id ?? internalId;

  return (
    <Field data-invalid={errors?.some(e => e?.message) ? 'true' : (required && !value ? 'true' : undefined)}>
      <FieldLabel htmlFor={inputId} className='gap-1'>
        {label} {required && <span className='text-destructive'>*</span>}
      </FieldLabel>

      <div className='relative'>
        <Icon icon={IconKey.DollarSign} size={14} className='absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground' />
        <Input
          ref={ref}
          id={inputId}
          type='number'
          step='0.01'
          min='0.01'
          placeholder={placeholder}
          className='pl-7'
          value={value}
          onChange={props.onChange}
          required={required}
          disabled={disabled}
          aria-invalid={required && !value ? 'true' : undefined}
          {...props}
        />
      </div>

      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldError errors={errors} />
    </Field>
  );
});
